import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { FOOTER_MAIN_LINKS, FOOTER_POLICY_LINKS } from "@/config/site";
import { BrandLogo } from "@/components/layout/BrandLogo";
import { buildStockWhatsAppUrl, isWhatsAppConfigured } from "@/lib/whatsapp";

export function SiteFooter() {
  const year = new Date().getFullYear();
  const waUrl = buildStockWhatsAppUrl();

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-nm-border bg-nm-bg2"
    >
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <BrandLogo className="h-16" testId="footer-brand-logo" />
            <p className="mt-4 max-w-sm text-sm text-nm-muted">
              Subscription digital pilihanmu, lebih mudah dipesan.
            </p>
            {isWhatsAppConfigured() && (
              <a
                href={waUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-wa hover:text-wa-hover"
              >
                <MessageCircle className="h-4 w-4" />
                Cek Stok via WhatsApp
              </a>
            )}
          </div>

          <div>
            <h3 className="text-sm font-bold text-nm-text">Navigasi</h3>
            <ul className="mt-3 space-y-2">
              {FOOTER_MAIN_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-nav-${link.to}`}
                    className="text-sm text-nm-muted transition-colors hover:text-nm-red"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-nm-text">Informasi</h3>
            <ul className="mt-3 space-y-2">
              {FOOTER_POLICY_LINKS.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    data-testid={`footer-policy-${link.to}`}
                    className="text-sm text-nm-muted transition-colors hover:text-nm-red"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-nm-border pt-6">
          <p className="text-xs text-nm-muted">
            © {year} Nofina Movie. Seluruh hak dilindungi.
          </p>
        </div>
      </div>
    </footer>
  );
}
